import type {TFunction} from 'i18next';
import {z} from 'zod';

export const recentSchoolNameOther = 'Other';

export const form202Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        schoolRegisteringFor: z.string({message: `${t('requiredErrorFull')}`}),
        studentStatus: z.string({message: `${t('requiredErrorFull')}`}),
        recentSchoolName: z.string({message: `${t('sef202Name')} ${t('requiredError')}`}),
        recentSchoolNameOther: z.string().nullish(),
        recentSchoolAddress: z.string().nullish(),
        recentSchoolCity: z.string().nullish(),
        recentSchoolState: z.string().nullish(),
        recentSchoolCountry: z.string().nullish(),
    });

export const form202Refine = (
    schema: ReturnType<typeof form202Schema>,
    t: TFunction<'translation', undefined>,
) => {
    return schema
        .refine(
            formData =>
                formData.recentSchoolName === recentSchoolNameOther
                    ? formData.recentSchoolNameOther
                    : true,
            {
                message: `${t('sef202NameOther')} ${t('requiredError')}`,
                path: ['recentSchoolNameOther'],
            },
        )
        .refine(
            formData =>
                formData.recentSchoolName === recentSchoolNameOther
                    ? formData.recentSchoolAddress
                    : true,
            {
                message: `${t('sef202Address')} ${t('requiredError')}`,
                path: ['recentSchoolAddress'],
            },
        )
        .refine(
            formData =>
                formData.recentSchoolName === recentSchoolNameOther
                    ? formData.recentSchoolCity
                    : true,
            {
                message: `${t('sef202City')} ${t('requiredError')}`,
                path: ['recentSchoolCity'],
            },
        )
        .refine(
            formData =>
                formData.recentSchoolName === recentSchoolNameOther
                    ? formData.recentSchoolCountry
                    : true,
            {
                message: `${t('sef202Country')} ${t('requiredError')}`,
                path: ['recentSchoolCountry'],
            },
        );
};
